import { CartGeoCode, CartGeoCodeState, CartMinimalGeoCode } from '../types';
import geoCodesAreEqual from './geoCodesAreEqual';
import cloneDeep from 'lodash/cloneDeep';

interface Args {
    geoCodes: CartGeoCode[];
    postalCode: string;
    selectedGeoCode?: CartMinimalGeoCode;
}

/**
 * Returns state structure common across geo code managers.
 *
 * This is a pure function that does not maintain state internally. State is
 * maintained by each specific consuming manager.
 *
 * @param args All input required for a state structure.
 */
const getGeoCodeState = (args: Args): CartGeoCodeState => {
    const geoCodes = cloneDeep(args.geoCodes);

    let matchingGeoCode: CartGeoCode = null;
    const [selectedGeoCode]: CartGeoCode[] = (
        args.selectedGeoCode && (
            matchingGeoCode =
                geoCodes.find((geoCode) =>
                    geoCodesAreEqual(geoCode, args.selectedGeoCode))
        ) ?
            [matchingGeoCode] :
        args.geoCodes.length === 1 ?
            geoCodes :
        [null]
    );

    const haveGeoCodeOptions = args.geoCodes.length > 0;

    return {
        geoCodes,
        selectedGeoCode,
        haveGeoCodeOptions,
        postalCodeIsInvalid: args.postalCode.length !== 0 && !haveGeoCodeOptions
    };
}

export default getGeoCodeState;
